export default "<tt-main></tt-main>\n"